import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBell, FaSearch, FaCaretDown, FaCog, FaTimes, FaCheck, FaSave } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { v4 as uuidv4 } from 'uuid';
import Sidebar from './Sidemenu';



const Assets = () => {
  const [category, setCategory] = useState('');
  const [showCategoryOptions, setShowCategoryOptions] = useState(false);
  const [language, setLanguage] = useState('');
  const [published, setPublished] = useState(false);
  const [publishAt, setPublishAt] = useState('');
  const [unpublishAt, setUnpublishAt] = useState('');

  const [storageLocation, setStorageLocation] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [description, setDescription] = useState('');
  const [imageMapping, setImageMapping] = useState({});
  const [title, setTitle] = useState('');
  const [imagePreview, setImagePreview] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [blockSearchEngines, setBlockSearchEngines] = useState(false);
  const [previewURL, setPreviewURL] = useState(null);
  const [showAccountOptions, setShowAccountOptions] = useState(false);
  const [storageType, setStorageType] = useState('Local'); // New state for storage type
  const navigate = useNavigate();

  const toggleAccountOptions = () => {
    setShowAccountOptions(!showAccountOptions);
  };

  const handleStorageTypeChange = (selectedStorageType) => {
    setStorageType(selectedStorageType);
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleFileSelect = (event) => {
    const imagefile = event.target.files[0];
    console.log("filename",imagefile)

    const reader = new FileReader();
    reader.onloadend = () => {
      if (imagefile) {
        setImagePreview(reader.result);
        setUploadedImage(URL.createObjectURL(imagefile));
      }
    };
    if (imagefile) {
      reader.readAsDataURL(imagefile);
    }
  };

  const modules = {
    toolbar: [
      
     
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{'list': 'ordered'}, {'list': 'bullet'},],
      ['link', 'image'],
      ['undo', 'redo'],
    ],
    
  };

  const formats = [
    
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image',
    'undo', 'redo',
  ];

  const handleDescriptionChange = (value) => {
    setDescription(value);
  };

  const handlePublishedSelect = (value) => {
    setPublished(value === 'Yes');
  };

  const handleSaveAndClose = async () => {
    try {
      const assetId = uuidv4();
      const data = {
        category,
        language,
       
        
        publishAt,
        unpublishAt,
        blockSearchEngines,
        storageLocation,
        selectedFile: selectedFile ? selectedFile.name : '',
        title,
        alias: document.getElementById('alias').value,
        description,
        assetId,
      };
  
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/saveAsset`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      if (response.ok) {
        console.log('Asset details saved successfully');
  
        // Map the title to the image file
        setImageMapping((prevMapping) => {
          const mappedImage = selectedFile ? selectedFile.name : '';
          console.log(`Mapped Title: ${title}, Mapped Image: ${mappedImage}`);
  
          return {
            ...prevMapping,
            [title]: mappedImage,
          };
        });
  
        const asset = { id: assetId, title, imagePreview };
  
        // Save the mapped file in the imageMapping state
        setImageMapping((prevMapping) => {
          
          return {
            ...prevMapping,
            [title]: asset.imagePreview,
          };
        });
  
      } else {
        console.error('Failed to save asset details');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  
  const handleApply = () => {
    const assetId = uuidv4();
    // Add code for handling Apply button click
  };

  const handleCancel = () => {
    navigate('/Components');
    setCategory('');
    setLanguage('');
    setPublished(false);
    setPublishAt('');
    setUnpublishAt('');
    setBlockSearchEngines(false);
    setStorageLocation('');
    setSelectedFile(null);
    setUploadedImage(null);
    setDescription('');
    setPreviewURL(null);
    setImagePreview('');
  };

  const handleCategorySelect = (selectedCategory) => {
    setCategory(selectedCategory);
    setShowCategoryOptions(false);
  };

  const handleLanguageSelect = (selectedLanguage) => {
    setLanguage(selectedLanguage);
  };

  const handlePublishAtSelect = (value) => {
    setPublishAt(value);
  };

  const handleUnpublishAtSelect = (value) => {
    setUnpublishAt(value);
  };

  return (
    <div style={{ display: 'flex' }}>
    
    <Sidebar />
    <div>
      
      {/* First rectangle */}
      <div className="content-container" style={{ border: '1px solid #ccc', marginLeft: '10px', marginTop: '-15px', paddingLeft: '10px', paddingRight: '10px', width: '1300px', height: '70px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <FaBell style={{ fontSize: '24px', marginRight: '20px' }} />
          <FaSearch style={{ fontSize: '24px' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* Profile Box */}
          <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
            <div style={{ border: '1px solid #ccc', borderRadius: '50%', width: '40px', height: '40px', overflow: 'hidden', marginRight: '10px' }}>
              {/* Add your profile image or icon here */}
            </div>
            <span style={{ marginRight: '2px' }}>EPICX</span>
            <div style={{ cursor: 'pointer' }} onClick={toggleAccountOptions}>
              <FaCaretDown />
            </div>
            {showAccountOptions && (
              <div style={{ position: 'absolute', top: '100%', right: '0', background: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '8px', zIndex: '1' }}>
                <p>Account</p>
                <p>Logout</p>
              </div>
            )}
          </div>

          {/* Settings Icon */}
          <div style={{ cursor: 'pointer', marginLeft: '10px' }}>
            <FaCog style={{ fontSize: '24px', marginLeft: '2px', marginRight: '10px' }} />
          </div>
        </div>
        {/* Additional content or components can be added here */}
      </div>

      {/* Second rectangle */}
      <div className="content-container" style={{ border: '1px solid #ccc', marginLeft: '10px', paddingLeft: '10px', paddingRight: '10px', width: '1300px', height: '80px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: '1000' }}>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: '30px', marginLeft: '30px' }}>
          <span>New Assets</span>
        </div>
        <div className="d-flex">
          <button className="btn btn-white" style={{ border: '1px solid #ccc' }} onClick={handleSaveAndClose}>
            <FaSave className="mr-0" style={{ color: '#007bff' }} /> Save & Close
          </button>
          <button className="btn btn-white mx-2" style={{ border: '1px solid #ccc' }} onClick={handleApply}>
            <FaCheck className="" style={{ color: '#007bff' }} /> Save
          </button>
          <button className="btn btn-white" style={{ border: '1px solid #ccc' }} onClick={handleCancel}>
            <FaTimes className="" style={{ color: 'red' }} /> Cancel
          </button>
        </div>
      </div>

      {/* Form Controls */}
      <div className="content-container mt-5" style={{ border: '1px solid #ccc', paddingLeft: '10px', paddingRight: '10px', width: '250px', height: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', position: 'absolute', top: '120px', right: '10px', zIndex: '999' }}>
        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="category" style={{ marginBottom: '5px', textAlign: 'left', width: '100px', fontWeight: 'bold' }}>Category</label>
          <select className="form-control mb-2" id="category" value={category} onChange={(e) => handleCategorySelect(e.target.value)} style={{ width: '107%' }}>
            <option value=""></option>
            <option value="Category 1">Uncategorized</option>
            <option value="Category 2">Create New Category..</option>
          </select>
        </div>

        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="language" style={{ marginBottom: '5px', textAlign: 'left', width: '100px', fontWeight: 'bold' }}>Language</label>
          <select className="form-control mb-2" id="language" value={language} onChange={(e) => handleLanguageSelect(e.target.value)} style={{ width: '107%' }}>
            <option value=""></option>
            <option value="English">English</option>
            <option value="Spanish">Spanish</option>
          </select>
        </div>

        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="blockSearchEngines" style={{ marginBottom: '5px', textAlign: 'left', width: '200px', fontWeight: 'bold' }}>Published </label>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '60%' }}>
            <label style={{ width: '35%' }}>
              <input type="radio" value="Yes" checked={published} onChange={() => handlePublishedSelect('Yes')} /> Yes
            </label>
            <label style={{ width: '45%' }}>
              <input type="radio" value="No" checked={!published} onChange={() => handlePublishedSelect('No')} /> No
            </label>
          </div>
        </div>

        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="publishAt" style={{ marginBottom: '5px', textAlign: 'left', width: '250px', fontWeight: 'bold' }}>Publish at (Date and Time)</label>
          <input type="datetime-local" className="form-control mb-2" id="publishAt" value={publishAt} onChange={(e) => handlePublishAtSelect(e.target.value)} style={{ width: '107%' }} />
        </div>

        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="unpublishAt" style={{ marginBottom: '5px', textAlign: 'left', width: '250px', fontWeight: 'bold' }}>Unpublish at (Date and Time)</label>
          <input type="datetime-local" className="form-control mb-2" id="unpublishAt" value={unpublishAt} onChange={(e) => handleUnpublishAtSelect(e.target.value)} style={{ width: '107%' }} />
        </div>

        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="blockSearchEngines" style={{ marginBottom: '5px', textAlign: 'left', width: '200px', fontWeight: 'bold' }}>Block search engines from indexing this file </label>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '60%' }}>
            <label style={{ width: '35%' }}>
              <input type="radio" value="Yes" checked={published} onChange={() => handlePublishedSelect('Yes')} /> Yes
            </label>
            <label style={{ width: '45%' }}>
              <input type="radio" value="No" checked={!published} onChange={() => handlePublishedSelect('No')} /> No
            </label>
          </div>
        </div>
      </div>

      <div className="content-container mt-5">
        <div className="form-group row">
          {/* Storage Location */}
          <div className="col-md-6" style={{ marginBottom: '20px' }}>
            <h5 style={{ marginBottom: '20px',marginLeft:'10px', marginTop: '-10px', textAlign: 'left', fontWeight: 'bold' }}>Storage Location</h5>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '50%' }}>
              <label
                style={{
                  width: '48%',
                  marginRight: '4%',
                  display: 'block',
                  marginLeft:'10px',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  backgroundColor: storageType === 'Local' ? '#fff' : '#ddd',
                  color: storageType === 'Local' ? '#000' : '#888',
                }}
                onClick={() => handleStorageTypeChange('Local')}
              >
                <input type="radio" style={{ display: 'none' }} checked={storageType === 'Local'} readOnly />
                Local
              </label>
              <label
                style={{
                  width: '48%',
                  display: 'block',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  backgroundColor: storageType === 'Remote' ? '#fff' : '#ddd',
                  color: storageType === 'Remote' ? '#000' : '#888',
                }}
                onClick={() => handleStorageTypeChange('Remote')}
              >
                <input type="radio" style={{ display: 'none' }} checked={storageType === 'Remote'} readOnly />
                Remote
              </label>
            </div>
          </div>

          {/* Preview */}
          <div className="col-md-6" style={{ marginBottom: '10px' }}>
            <h5 style={{ marginBottom: '20px', marginTop: '-10px', textAlign: 'left', fontWeight: 'bold' }}>Preview</h5>
            <div style={{ border: '1px solid #ccc', borderRadius: '4px', padding: '10px', width: '250px', height: '120px' }}>
              {imagePreview && (
                <img
                  src={imagePreview}
                  alt={`Preview - ${title}`}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              )}
            </div>
          </div>

        </div>
      </div>

      {/* Upload a file section */}
<div className="content-container mt-5">
  <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%', marginTop: '-100px' ,marginLeft:'12px',}}>
    {storageType === 'Local' && (
      <div>
        <h5 style={{ marginBottom: '20px', marginTop: '-10px', textAlign: 'left', fontWeight: 'bold' }}>Upload a file (max filesize allowed = 6 MB)</h5>
        <label htmlFor="fileInput" className="custom-file-upload center">
          <input
            type="file"
            id="fileInput"
            className="form-control-file"
            onChange={handleFileSelect}
            
            style={{ display: 'none' }}
          />
          <div style={{ border: '1px solid black', height: '280px', width: '500px', padding: '20px', textAlign: 'center', position: 'relative' }}>
            {previewURL && (
              <img src={previewURL} alt="Preview" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
            )}
            {uploadedImage && (
              <img
                src={uploadedImage}
                alt="Chosen File"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'contain' }}
              />
            )}
          </div>
        </label>
      </div>
    )}
    {storageType === 'Remote' && (
  <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '30%' }}>
    <label htmlFor="remoteUrl" style={{ marginBottom: '5px', textAlign: 'left', width: '100px', fontWeight: 'bold' }}>Remote URL</label>
    <input type="text" className="form-control mb-2" id="remoteUrl" placeholder="Enter Remote URL" />
  </div>
)}

  </div>
</div>


      {/* Text Editors */}
      <div className="content-container mt-5" style={{ marginBottom: '50px' }}>
        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="title" style={{ marginBottom: '5px',marginLeft:'10px', textAlign: 'left',fontWeight: 'bold' ,width:'30%'}}>Title</label>
          <input type="text" className="form-control mb-2" style={{ width:'30%',marginLeft:'10px',}} id="title" value={title} onChange={handleTitleChange}  />
        </div>
        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%' }}>
          <label htmlFor="alias" style={{ marginBottom: '5px', textAlign: 'left', width: '100px', fontWeight: 'bold',marginLeft:'10px',}}>Alias</label>
          <input type="text" className="form-control mb-2" id="alias" style={{ width: '29%',marginLeft:'10px' }} />
        </div>
        <div className="form-group" style={{ marginBottom: '20px', marginRight: '10px', width: '100%',marginLeft:'10px',height:'-20%' }}>
          <label htmlFor="description" style={{ marginBottom: '5px', textAlign: 'left', width: '100px', fontWeight: 'bold',marginLeft:'10px',height:'-20%' }}>Description</label>
          <textarea
            theme="snow" 
            value={description}
            onChange={handleDescriptionChange}
            modules={modules }
            formats={formats}
            style={{ height: '150px', width: '100%' }}
          />
        </div>
      </div>
    </div>
    </div>
  );
};

export default Assets;
